/*************************************************/
/* Collapsed text                                */
/*************************************************/


export function collapsedText() {
    const collapsedTextElementSelector = ".collapsed-text__text.collapsed";
    const collapsedClass = "collapsed";
    const triggerElementSelector = ".collapsed-text__bottom";

    const init = function () {
        $(document).on('click',
            triggerElementSelector,
            function () {
                var collapsedTextElement = $(this).prev(collapsedTextElementSelector);
                collapsedTextElement.css('height', collapsedTextElement.prop('scrollHeight'));
                collapsedTextElement.removeClass(collapsedClass);
                $(this).remove();
            });
    };



    init();
}